import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const init = (isRM) => {
  const solutions = document.querySelectorAll('.solutions');
  if (solutions.length > 0) {
    solutions.forEach((solution) => {
      const solutionsNav = solution.querySelector('.solutions__list');
      const trigger = solution.querySelector('.solutions__solution-list');
      ScrollTrigger.create({
        trigger,
        start: 'top 50%',
        end: 'bottom top+=25%',
        onUpdate: (self) => gsap.set(solution, { '--progress': self.progress })
      });
      const links = solution.querySelectorAll('.solutions__link');
      if (links.length > 0) {
        links.forEach((link) => {
          const element = document.querySelector(link.getAttribute('href'));

          if (!isRM) {
            gsap.to(element, {
              keyframes: {
                opacity: [0, 1]
              },
              ease: 'circ.in',
              overwrite: true,
              scrollTrigger: {
                trigger: element,
                start: 'top bottom',
                end: 'top top+=33%',
                scrub: true
              }
            });

            gsap.fromTo(
              element,
              {
                opacity: 1
              },
              {
                opacity: 0,
                ease: 'sine',
                scrollTrigger: {
                  trigger: element,
                  start: 'bottom top+=30%',
                  end: 'bottom top',
                  scrub: true
                }
              }
            );
          } else {
            gsap.set(element, { opacity: 1 });
          }

          ScrollTrigger.create({
            trigger: element,
            start: 'top center',
            end: 'bottom center',
            snap: 0,
            onToggle: (self) => self.isActive && setActive(link)
          });

          link.addEventListener('click', (e) => {
            e.preventDefault();
            gsap.to(window, {
              scrollTo: { y: element, offsetY: 90 },
              overwrite: 'auto'
            });
          });
        });

        const setActive = (target) => {
          links.forEach((el) => el.classList.remove('active'));
          target.classList.add('active');
          if (innerWidth < 1080) {
            gsap.to(solutionsNav, { duration: 1, scrollTo: { x: target } });
          }
        };
      }
    });
  }
  // end
};

export { init };
